"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villanterio": {
    "a58ce28d": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "ca-pandina": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b94c6e44": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "cascinetta": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7b71b87": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "castellazzo": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f709c302": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "castellere": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4887dfb6": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "cattanea": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bdbdf77f": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "falcone": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7812356d": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "goredo": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "47cc5a76": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "malcontenta": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4322ab9d": [{
      "hkey": "e1919747",
      "slug": "bolognola",
      "name": "Bolognola",
      "primary": true,
      "skipSearch": false
    }],
    "monte-bolognola": [{
      "hkey": "e1919747",
      "slug": "bolognola",
      "name": "Bolognola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8fa40bb5": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "nuova": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea81683c": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "pomeo": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9172640": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "skipSearch": false
    }],
    "tombone": [{
      "hkey": "a04477bc",
      "slug": "villanterio",
      "name": "Villanterio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;